import type { AxiosInstance } from 'axios';
import type { CiselnikyCiselnikPolozkaSeznamDto } from '../generated';

const phoneCountryCodesQuery = async (
	axiosInstance: AxiosInstance
): Promise<CiselnikyCiselnikPolozkaSeznamDto> => {
	const { data } = await axiosInstance.get(
		'/api/v1/ciselniky/PREDVOLBA_EU/polozky'
	);
	return data;
};

export const getPhoneCountryCodesQuery = (axiosInstance: AxiosInstance) => ({
	queryKey: ['phone-country-codes'],
	queryFn: () => phoneCountryCodesQuery(axiosInstance),
});
